export const BREEZE_TOOLTIP_DELAY = 500; // 500ms